const currentUser = () => {
  let authDetails = localStorage.getItem('authDetails');
  if (authDetails) {
    authDetails = JSON.parse(authDetails);
  }
  return authDetails;
};

export default currentUser;
